import api from "@/services/api";
import { PlayersFilterDtoIn, PlayerReport, PlayerAnalytics, PlayerExportModel } from "./types";

export async function getFilteredPlayers(model: PlayersFilterDtoIn): Promise<PlayerReport[]> {
    return new Promise((resolve, reject) => {
        api.post("/reports/filterPlayers/", model).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function getPlayerAnalytics(): Promise<PlayerAnalytics> {
    return new Promise((resolve, reject) => {
        api.get("/reports/playerAnalytics").then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function exportPlayerReport(model: PlayerExportModel): Promise<any> {
    return new Promise((resolve, reject) => {
        api.postDownloadFile("/reports/exportPlayerReport/", model).then(
            response => {
                var blob = new Blob([response.data], { type: response.headers["content-type"] });
                var downloadElement = document.createElement("a");
                var href = window.URL.createObjectURL(blob); // Create a downloaded link
                downloadElement.href = href;
                downloadElement.download = response.headers.filename; // filename after download
                // This is compatible with Firefox browser
                document.body.appendChild(downloadElement);
                downloadElement.click(); // Click to download
                document.body.removeChild(downloadElement); // Download completed removes the element
                window.URL.revokeObjectURL(href);
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}
